import {
  IoBagHandleOutline, IoWaterOutline, IoCarOutline,
  IoCheckmarkDoneOutline, IoCheckmark, IoCloseCircle,
  IoCubeOutline, IoHomeOutline,
} from "react-icons/io5";
import { BAG_FIRST } from "../bagFirst";

// 注文の進行をタイムラインで表す。
// 通常注文（4ステップ）— otype: 1,2=集荷 / 3,4,5=洗濯 / 6,7=お届け / 8=完了 / 11=キャンセル
const STEPS = [
  { key: 'pickup', label: '集荷', Icon: IoBagHandleOutline },
  { key: 'clean', label: '洗濯', Icon: IoWaterOutline },
  { key: 'deliver', label: 'お届け', Icon: IoCarOutline },
  { key: 'done', label: '完了', Icon: IoCheckmarkDoneOutline },
];

// bag-first（2026-09-01の初回登録フロー刷新）の5ステップ。
// 「専用バッグが届くのを待つ → 自分で集荷を依頼する」という、通常注文には無い
// 前半2工程が入るため、通常の4ステップでは現在地を表せない。
const BAG_FIRST_STEPS = [
  { key: 'bag_deliver', label: 'バッグお届け', Icon: IoCubeOutline },
  { key: 'bag_arrived', label: 'バッグ到着', Icon: IoHomeOutline },
  { key: 'pickup', label: '集荷依頼', Icon: IoBagHandleOutline },
  { key: 'clean', label: 'クリーニング', Icon: IoWaterOutline },
  { key: 'deliver', label: 'お届け', Icon: IoCarOutline },
];

function stageFromOtype(otype) {
  const n = Number(otype);
  if (n === 8) return 3;
  if (n === 6 || n === 7) return 2;
  if (n >= 3 && n <= 5) return 1;
  return 0; // 1,2 など
}

// bag-first注文の現在地。bag_status が集荷依頼までを、otype がそれ以降を受け持つ。
function stageFromBagStatus(order) {
  const bagStatus = String(order.bag_status || '');
  const n = Number(order.otype);
  if (n === 8) return 5;            // 全工程完了
  if (n === 6 || n === 7) return 4; // お届け
  if (n >= 3 && n <= 5) return 3;   // クリーニング
  if (n === 2) return 2;            // 集荷済み・拠点へ配送中
  if (bagStatus === 'requested') return 2;
  if (bagStatus === 'arrived') return 1;
  return 0;                          // delivering
}

export const OrderProgress = ({ order }) => {
  // キャンセルは専用表示
  if (Number(order.otype) === 11) {
    return (
      <div className="oprog oprog--canceled">
        <IoCloseCircle aria-hidden="true" className="oprog_cancel_icon" />
        <span>この注文はキャンセルされました</span>
      </div>
    );
  }

  const isBagFirst = BAG_FIRST && !!String(order.bag_status || '');
  const steps = isBagFirst ? BAG_FIRST_STEPS : STEPS;
  const current = isBagFirst ? stageFromBagStatus(order) : stageFromOtype(order.otype);

  return (
    <div className="oprog" role="list" aria-label="注文の進行状況">
      {steps.map((step, i) => {
        const state = i < current ? 'done' : i === current ? 'current' : 'todo';
        const Glyph = state === 'done' ? IoCheckmark : step.Icon;
        return (
          <div className={`oprog_step is-${state}`} role="listitem" key={step.key}>
            {i > 0 && <span className={`oprog_line ${i <= current ? 'is-filled' : ''}`} aria-hidden="true" />}
            <span className="oprog_node" aria-hidden="true">
              <Glyph />
            </span>
            <span className="oprog_label">{step.label}</span>
          </div>
        );
      })}
    </div>
  );
};

export default OrderProgress;
